var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex absolute top-0 left-0 justify-center items-center w-full h-full"},[_c('div',{staticClass:"loader",class:[_vm.color, _vm.size]})])}
var staticRenderFns = []

export { render, staticRenderFns }